import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { useCanvasStore } from '@/modules/canvas/store';

import { useActiveDistconStore } from '../store/useActiveDistconStore';
import { IDistconService } from './IDistconService';
import { DistconServiceExceptionDecorator } from './DistconServiceExceptionDecorator';
import { DistconServiceLogDecorator } from './DistconServiceLogDecorator';
import { DistconServiceImpl } from './DistconServiceImpl';

export class DistconServiceFactory {
  private static instance: DistconServiceFactory | null = null;
  private floorplanDesignStore: typeof useFloorplanDesignStore;
  private canvasStore: typeof useCanvasStore;
  private activeDistconStore: typeof useActiveDistconStore;

  public static initialize(
    floorplanDesignStore: typeof useFloorplanDesignStore,
    canvasStore: typeof useCanvasStore,
    activeDistconStore: typeof useActiveDistconStore,
  ) {
    DistconServiceFactory.instance = new DistconServiceFactory(
      floorplanDesignStore,
      canvasStore,
      activeDistconStore,
    );
  }

  public static getInstance() {
    if (DistconServiceFactory.instance === null) {
      throw new Error(
        'DistconServiceFactory not yet initialized. Call DistconServiceFactory.initialize() first.',
      );
    }
    return DistconServiceFactory.instance;
  }

  private constructor(
    floorplanDesignStore: typeof useFloorplanDesignStore,
    canvasStore: typeof useCanvasStore,
    activeDistconStore: typeof useActiveDistconStore,
  ) {
    this.floorplanDesignStore = floorplanDesignStore;
    this.canvasStore = canvasStore;
    this.activeDistconStore = activeDistconStore;
  }

  public createDistconService(): IDistconService {
    let result: IDistconService = this.makeDistconService();

    result = new DistconServiceExceptionDecorator(result);
    result = new DistconServiceLogDecorator(result);

    return result;
  }

  private makeDistconService(): IDistconService {
    return new DistconServiceImpl(
      this.floorplanDesignStore,
      this.canvasStore,
      this.activeDistconStore,
    );
  }
}
